export const bytesToSize = (bytes) => {
  var sizes = ["B", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "0 Byte";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

export function toTimestamp(strDate) {
  var datum = Date.parse(strDate);
  return datum / 1000;
}

export const timeConversion = (millisec) => {
  var seconds = Math.round(millisec / 1000);

  var minutes = Math.round(millisec / (1000 * 60));

  var hours = Math.round(millisec / (1000 * 60 * 60));

  var days = millisec / (1000 * 60 * 60 * 24);

  if (seconds < 60) {
    return seconds + " sek";
  } else if (minutes < 60) {
    return minutes + " min";
  } else if (hours < 24) {
    return hours + " val";
  } else {
    return days + " diena";
  }
};

export const msToDHS = (ms) => {
  const days = Math.floor(ms / (24 * 60 * 60 * 1000));
  const daysms = ms % (24 * 60 * 60 * 1000);
  const hours = Math.floor(daysms / (60 * 60 * 1000));
  const hoursms = ms % (60 * 60 * 1000);
  const minutes = Math.floor(hoursms / (60 * 1000));
  const minutesms = ms % (60 * 1000);
  const sec = Math.floor(minutesms / 1000);
  return `${days ? days + "dienos" : ""} ${hours ? hours + "val" : ""} ${
    minutes && minutes + "min"
  } ${sec && sec + "sek"}`;
};

export const getDate = (ms) => {
  var date = new Date(ms);
  const hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  const minutes =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  const seconds =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  const month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var str =
    date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + minutes;

  return str;
};

export const formatDate = (date) => {
  const addZero = (item) => {
    if (item === 0) {
      return "00";
    } else {
      return item;
    }
  };
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    hour = d.getHours(),
    min = d.getMinutes(),
    sec = d.getSeconds();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (hour < 10) hour = "0" + hour;
  if (min < 10) min = "0" + min;
  if (sec < 10) sec = "0" + sec;

  return (
    [year, month, day].join("-") +
    "T" +
    addZero(hour) +
    ":" +
    addZero(min) +
    ":" +
    addZero(sec)
  );
};

export const formatDateS = (date) => {
  var date = new Date(date);
  const hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  const minutes =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  const seconds =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  const month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var str =
    date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + minutes;

  return str;
};
